import {EMAIL_TEMPLATE_TYPE} from '@/utils/enums';

export const radioList = [
	{
		value: EMAIL_TEMPLATE_TYPE.TABLE_UPDATE,
		label: 'Send update table email',
		description: 'Email hosts with a link to update their guest list.',
	},
	{
		value: EMAIL_TEMPLATE_TYPE.PATRON_UPDATE,
		label: 'Send update info email',
		description: 'Email guests with a link to update their contact information and add an optional payment method.',
	},
	{
		value: EMAIL_TEMPLATE_TYPE.AUCTION,
		label: 'Send auction website',
		description: 'Email all guests a link to the auction website.',
	},
	{
		value: EMAIL_TEMPLATE_TYPE.INVOICES,
		label: 'Send Email Invoices',
		description: 'Email invoices to guests with outstanding balances.',
	},
	{
		value: EMAIL_TEMPLATE_TYPE.CONTRIBUTIONS_SUMMARY,
		label: 'Send contributions summary',
		description: 'Email a summary of all contributions made during the event.',
	},
];
